import { render, staticRenderFns } from "./stats-filter.vue?vue&type=template&id=b36da8cc&"
import script from "./stats-filter.vue?vue&type=script&lang=js&"
export * from "./stats-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports